import { useSignUrlForFormMutation } from '../../__generated__/chirp/com/hubspot/url/signer/rpc/UrlSignerRpc.hooks';
const useGetSignedUrl = (options = {}) => {
  const [signUrl, result] = useSignUrlForFormMutation(options);
  return Object.assign({
    signUrl
  }, result);
};
export default useGetSignedUrl;